import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import UploadGuide from "./UploadGuide";
import { whoIsAthleteCoach } from "../../../../utils/user-helpers";
import SvgIcon from "../../../../parts/SvgIcon";
import GeneralResources from "./GeneralResources";

const Guides = ({
  locals,
  athlete,
  referAsClients,
  coachOrganizationInformation = undefined,
  activeUser,
}) => {
  const { t } = useTranslation(["athlete-portal", "common"]);
  const { _id: athleteId } = athlete;

  const userToRequest =
    !!coachOrganizationInformation &&
    String(
      whoIsAthleteCoach(
        activeUser.athletes,
        athleteId,
        activeUser._id,
        coachOrganizationInformation._id
      )
    ) !== String(activeUser._id)
      ? coachOrganizationInformation._id
      : activeUser._id;

  const [canSubmit, setCanSubmit] = useState(false);
  const [addingResource, setAddingResource] = useState("none");
  const [editingResource, setEditingResource] = useState(null);

  const mealInputRef = useRef(null);
  const supplementInputRef = useRef(null);

  const handleBeforeSubmit = () => {
    if (mealInputRef.current.value) {
      mealInputRef.current.disabled = false;
    }

    if (supplementInputRef.current.value) {
      supplementInputRef.current.disabled = false;
    }
  };

  const handleAfterSubmit = () => {
    setTimeout(() => {
      // Check input values using refs before disabling
      if (mealInputRef.current.value) {
        mealInputRef.current.disabled = true;
      }

      if (supplementInputRef.current.value) {
        supplementInputRef.current.disabled = true;
      }

      if (addingResource !== "none") {
        setAddingResource("none");
      }
    }, 200);
  };

  return (
    <div role="guides-wrapper">
      <header>
        <div>
          <h4>{t("guides.title")}</h4>
          <p className="p5">
            {t("guides.description", {
              role: referAsClients ? t("programs.client") : t("programs.athlete"),
            })}
          </p>
        </div>
        <a
          href="/coaching-portal/msb-university?product=pull"
          className="chip success"
        >
          {t("guides.newBadge")}
        </a>
      </header>
      <form
        encType="multipart/form-data"
        method="POST"
        data-noreset
        action={`/actions/guides/save${
          editingResource ? `/${editingResource}` : ""
        }`}
        onSubmit={handleAfterSubmit}
      >
        <input type="hidden" name="athleteId" value={athleteId} />
        <div>
          <article>
            <p className="p4">{t("guides.uploadMealPlan")}</p>
            <UploadGuide
              name="meal-file"
              prefix=""
              setcansubmit={setCanSubmit}
              inputRef={mealInputRef}
              athlete={athlete}
              field="meal"
              coachOrganizationInformation={coachOrganizationInformation}
              activeUser={activeUser}
            />
          </article>
          <article>
            <p className="p4">{t("guides.uploadSupplementGuide")}</p>
            <UploadGuide
              name="supplement-file"
              prefix=""
              setcansubmit={setCanSubmit}
              inputRef={supplementInputRef}
              athlete={athlete}
              field="supplement"
              coachOrganizationInformation={coachOrganizationInformation}
              activeUser={activeUser}
            />
          </article>
          <input
            name="userToRequest"
            id="userToRequest"
            defaultValue={userToRequest}
            style={{ display: "none" }}
          ></input>
          {editingResource && (
            <input
              name="resourceId"
              id="resourceId"
              defaultValue={editingResource}
              style={{ display: "none" }}
            ></input>
          )}
        </div>

        <GeneralResources
          locals={locals}
          athlete={athlete}
          addingResource={addingResource}
          setAddingResource={setAddingResource}
          coachOrganizationInformation={coachOrganizationInformation}
          setEditingResource={setEditingResource}
          editingResource={editingResource}
        />

        <footer>
          {addingResource === "none" && (
            <button
              onClick={handleBeforeSubmit}
              disabled={!canSubmit}
              data-button-type="primary"
            >
              {t("common:save")}
            </button>
          )}
        </footer>
      </form>
    </div>
  );
};

module.exports = Guides;
